import { PaymentRequirementsIncomingState } from "./interface";

export default <PaymentRequirementsIncomingState> {
	unprocessedList: [],
	unprocessedListLoading: false,
	unprocessedListShowed: true,
	cardIndexDetails: {},
}